<template>
	<v-card flat outlined>
		<v-card-text>
			<v-row class="d-flex justify-space-between ml-8">
				<v-flex xs12 md6 lg6 class="pr-16">
					<Dropdown
						v-model="appointment.appointment_location_id"
						:ajax="true"
						:data="'appointment-locations'"
						:label="'* ' + $t('fields.appointmentLocation')"
					></Dropdown>
				</v-flex>
				<v-flex class="d-flex justify-end" v-if="appointment.appointment_location_id !== null">
					<v-btn
						v-if="
							appointment.id != null &&
							appointment.id != 0 &&
							appointment.planned_course_id == plannedCourseId &&
							canEdit
						"
						class="mt-2 ml-2"
						color="warning"
						@click="deleteAppointment(appointment.id)"
					>
						<v-icon small>fa-trash</v-icon>&nbsp;{{ $t('buttons.delete') }}
					</v-btn>
					<v-btn
						v-if="
							appointment.id != null &&
							appointment.id != 0 &&
							appointment.planned_course_id == plannedCourseId &&
							canEdit
						"
						class="mt-2 ml-2 mr-2"
						color="primary"
						@click="editAppointment()"
					>
						<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
					</v-btn>
					<v-btn v-if="canEdit" class="mt-2 ml-2 mr-2" color="primary" @click="addAppointment()">
						<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addAppointment') }}
					</v-btn>
				</v-flex>
			</v-row>
			<v-row v-if="appointment.appointment_location_id !== null">
				<v-flex lg6 xs12 sm12 class="pa-2">
					<Calendar
						:appointmentLocationId="appointment.appointment_location_id"
						:plannedCourseId="plannedCourseId"
						@appointmentFetched="loadData"
					></Calendar
				></v-flex>
				<v-flex lg6 xs12 sm12 class="pa-2" v-if="appointment.id != 0">
					<v-row>
						<v-col cols="12">
							<v-col cols="12">
								<DatePicker
									:disabled="true"
									v-model="appointment.date"
									:date-label="'* ' + $t('fields.date')"
								></DatePicker>
							</v-col>
							<v-col cols="12">
								<InputField
									:disabled="true"
									v-model="appointment.teacher.full_name"
									:label="'* ' + $t('fields.teacher')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<InputField
									:disabled="true"
									v-model="appointment.course_module.name"
									:label="'* ' + $t('fields.module')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<TimePicker2
									v-model="appointment.start_time"
									:disabled="true"
									:label="'* ' + $t('fields.startAppointmentTime')"
								></TimePicker2>
							</v-col>
							<v-col cols="12">
								<TimePicker2
									v-model="appointment.end_time"
									:disabled="true"
									:label="'* ' + $t('fields.endAppointmentTime')"
								></TimePicker2>
							</v-col>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<v-card flat outlined>
								<v-card-text class="pt-0">
									<Participants
										:plannedCourseId="plannedCourseId"
										:appointmentId="appointment.id"
										:appointmentLocationId="appointment.appointment_location_id"
										:canEdit="canEdit"
									></Participants>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-flex>
			</v-row>
		</v-card-text>
		<v-row v-if="showModal">
			<v-col>
				<Modal :show-modal="showModal">
					<AppointmentForm
						:appointmentId="appointment.id"
						:plannedCourseId="plannedCourseId"
						:appointmentLocationId="appointment.appointment_location_id"
						:courseId="courseId"
						@close="closeModal"
					></AppointmentForm>
				</Modal>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import Dropdown from '../../trinkets/Dropdown';
import DatePicker from '../../trinkets/DatePicker';
import InputField from '../../trinkets/InputField';
import TimePicker2 from '../../trinkets/TimePicker2';
import Calendar from './Calendar';
import Modal from '../../trinkets/Modal';
import Appointment from '../../../models/Appointment';
import AppointmentForm from './AppointmentForm';
import Participants from './Participants';

export default {
	name: 'Appointments',
	components: {
		Dropdown,
		DatePicker,
		Calendar,
		InputField,
		TimePicker2,
		AppointmentForm,
		Modal,
		Participants,
	},
	props: {
		courseId: [String, Number],
		plannedCourseId: [String, Number],
		locationId: [String, Number],
		courseStatus: [String, Number],
		canEdit: Boolean,
	},
	emits: ['reloadCalendar'],
	watch: {},
	data() {
		return {
			appointment: new Appointment({}),
			inEditMode: false,
			showModal: false,
		};
	},
	methods: {
		editAppointment() {
			this.inEditMode = true;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
			this.appointment.id = 0;
		},
		addAppointment() {
			this.inEditMode = true;
			this.showModal = true;
			this.appointment.id = 0;
		},
		loadData(data) {
			let usableData = JSON.parse(JSON.stringify(data));
			this.appointment = usableData;
		},
		deleteAppointment(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					vm.$APICall(
						'delete',
						'appointments/' + id + '/delete',
						{ planned_course_id: this.$route.params.id, id: id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
								vm.$modalBus.$emit('reloadCalendar', vm.appointment.appointment_location_id);
								vm.$modalBus.$emit('reloadTeachersOnCourse');
								vm.$modalBus.$emit('reloadSchedule');
								vm.$modalBus.$emit('reloadPlannedCourse');
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},
	},
};
</script>

<style scoped></style>
